import { useState, useCallback } from 'react';

/**
 * Simple hook for managing internal question selection state
 * This is only for internal usage in the AlgoliaIndexTable component
 * External selection handling should be provided via props
 */
const useQuestionSelection = () => {
  const [selectedQuestions, setSelectedQuestions] = useState<string[]>([]);

  const handleQuestionSelect = useCallback((questionId: string, selected: boolean) => {
    if (selected) {
      setSelectedQuestions((prev) => [...prev, questionId]);
    } else {
      setSelectedQuestions((prev) => prev.filter((id) => id !== questionId));
    }
  }, []);

  return {
    selectedQuestions,
    setSelectedQuestions,
    handleQuestionSelect,
  };
};

export default useQuestionSelection;
